<template>
  <div class="pa-2" style="background: rgba(0,0,0,0.02); min-height: 100vh;">
    <FormTemplateFieldSelector
      :templateID="$route.params.id"
      v-if="!loading && fieldSelecting"
      @select="fieldSelecting = false;editpagebreak.conditional_question_id = arguments[0].question_id; editpagebreak.conditional_fieldtype_id = arguments[0].fieldtype_id"
      @cancel="fieldSelecting = false"
    />

    <div class="d-flex align-center justify-space-between mb-4" style="width: 100%;">
      <div class="text-h6 text-truncate" style="min-width: 0; flex-shrink: 1;">Page Break Settings</div>
      <div class="d-flex align-center flex-shrink-0 ml-2">
        <v-btn small text dense @click="$emit('cancel')">Cancel</v-btn>
        <v-btn small color="info" @click="save" class="ml-2">Save</v-btn>
      </div>
    </div>

    <v-alert
      :value="true"
      type="info"
      class="mb-4"
      dense
    >
      Page Breaks have no configurable options, except for part visibility.
    </v-alert>

    <v-divider class="my-4" />

    <div class="text-subtitle-2 mb-2">Display Settings</div>
    <v-checkbox
      v-model="editpagebreak.web_only"
      label="Hide on PDF (Web Only)"
      class="mt-0 mb-2"
    />
    <v-checkbox
      v-model="editpagebreak.pdf_only"
      label="PDF Only"
      persistent-hint
      hint="Do not show on Web"
      class="mt-0 mb-4"
    />

    <v-divider class="my-4" />

    <div class="text-subtitle-2 mb-2">Conditional Visibility</div>
    <v-checkbox
      v-model="conditional_part"
      label="Conditional Form Part"
      persistent-hint
      hint="Display part depending on answer to question"
      class="mt-0 mb-4"
    />
    
    <div v-if="conditional_part" class="pl-3" style="border-left: 2px solid #eee;">
      <v-text-field
        v-model="editpagebreak.conditional_question_id"
        label="Question ID"
        disabled
        class="mb-4"
      />
      <v-text-field
        v-model="editpagebreak.conditional_fieldtype_id"
        label="Fieldtype ID"
        disabled
        class="mb-4"
      />
      <v-text-field
        v-model="editpagebreak.conditional_value"
        label="Conditional Value"
        class="mb-4"
      />
      <v-checkbox
        v-model="editpagebreak.conditional_apply_pdf"
        label="Apply to PDF"
        persistent-hint
        hint="Hide from PDF if part fails condition"
        class="mt-0 mb-4"
      />
      <v-btn 
        small
        outlined
        @click="fieldSelecting = true"
        class="mb-4"
      >
        Select a field
      </v-btn>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FormTemplateFieldSelector from '@/components/admin/FormTemplateFieldSelector'

export default {
  name: 'PageBreakProperties',
  props: [ 'partId', 'newPart' ],
  components: {
    FormTemplateFieldSelector
  },
  data () {
    return {
      editpagebreak: {},
      loading: false,
      conditional_part: false,
      fieldSelecting: false
    }
  },
  created () {
    this.editpagebreak = JSON.parse(JSON.stringify(this.pagebreak))
    this.conditional_part = (this.editpagebreak.conditional_question_id)
    this.$nextTick(() => {
      if (this.newPart) {
        this.save()
      }
    })
  },
  computed: {
    ...mapGetters('formtemplate', [
      'partById',
    ]),
    pagebreak: function () {
      return this.partById(this.partId) || this.newPart
    }
  },
  methods: {
    ...mapActions('formtemplate', [
      'savePagebreak'
    ]),
    save () {
      this.loading = true
      if(!this.conditional_part){
        this.editpagebreak.conditional_question_id = null
        this.editpagebreak.conditional_fieldtype_id = null
        this.editpagebreak.conditional_apply_pdf = false
        this.editpagebreak.conditional_value = ""
      }
      this.savePagebreak(this.editpagebreak)
        .then(pagebreak => {
          this.$emit('save', pagebreak)
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
  .adv_settings {
      padding:0 10px;
      padding: 0 25px 0 25px;
      border-top: 1px solid rgba(0,0,0,0.1)
  }
</style>
